import React from 'react';

// Import local perk icons
import djIcon from '@/assets/perks/dj.png';
import drink1Icon from '@/assets/perks/drink-1.png';
import drink2Icon from '@/assets/perks/drink-2.png';
import drink3Icon from '@/assets/perks/drink-3.png';
import drinkIcon from '@/assets/perks/drink.png';
import drinksIcon from '@/assets/perks/drinks.png';
import hatIcon from '@/assets/perks/hat.png';
import nightclubIcon from '@/assets/perks/nightclub.png';
import nightlife1Icon from '@/assets/perks/nightlife-1.png';
import nightlife3Icon from '@/assets/perks/nightlife-3.png';
import nightlifeIcon from '@/assets/perks/nightlife.png';
import partyIcon from '@/assets/perks/party.png';
import vintageIcon from '@/assets/perks/vintage.png';

export const PERK_ICONS: { name: string; icon: string }[] = [
  { name: 'DJ', icon: djIcon },
  { name: 'Drink (Style 1)', icon: drink1Icon },
  { name: 'Drink (Style 2)', icon: drink2Icon },
  { name: 'Drink (Style 3)', icon: drink3Icon },
  { name: 'Drink', icon: drinkIcon },
  { name: 'Drinks', icon: drinksIcon },
  { name: 'Hat', icon: hatIcon },
  { name: 'Nightclub', icon: nightclubIcon },
  { name: 'Nightlife (Style 1)', icon: nightlife1Icon },
  { name: 'Nightlife (Style 3)', icon: nightlife3Icon },
  { name: 'Nightlife', icon: nightlifeIcon },
  { name: 'Party', icon: partyIcon },
  { name: 'Vintage', icon: vintageIcon },
];

interface PerkIconProps {
  icon: string;
  className?: string;
}

export const PerkIcon: React.FC<PerkIconProps> = ({ icon, className }) => {
  const getIconSrc = (name: string) => {
    // Exact match trial first
    const match = PERK_ICONS.find(p => p.name === name);
    if (match) return match.icon;

    // Fallback to normalized matching
    const normalized = name.toLowerCase().replace(/_/g, '-');
    switch (normalized) {
      case 'dj':
      case 'music':
      case 'sound':
        return djIcon;
      case 'wine':
      case 'bottle':
      case 'private-bar':
      case 'alcohol':
      case 'drink':
        return drinkIcon;
      case 'drinks':
      case 'refreshment':
      case 'food':
      case 'catering':
        return drinksIcon;
      case 'drink-1':
      case 'drink (style 1)':
        return drink1Icon;
      case 'drink-2':
      case 'drink (style 2)':
        return drink2Icon;
      case 'drink-3':
      case 'drink (style 3)':
        return drink3Icon;
      case 'hat':
      case 'cloakroom':
      case 'secure-cloakroom':
      case 'shirt':
        return hatIcon;
      case 'nightclub':
      case 'host':
      case 'dedicated-host':
      case 'user':
        return nightclubIcon;
      case 'early-entry':
      case 'clock':
      case 'time':
      case 'nightlife-1':
      case 'nightlife (style 1)':
        return nightlife1Icon;
      case 'secure':
      case 'security':
      case 'shield':
      case 'shield-check':
      case 'nightlife-3':
      case 'nightlife (style 3)':
        return nightlife3Icon;
      case 'zap':
      case 'express-entry':
      case 'fast-track':
      case 'ticket':
      case 'voucher':
      case 'champagne-voucher':
      case 'nightlife':
        return nightlifeIcon;
      case 'party-popper':
      case 'celebration':
      case 'event':
      case 'party':
        return partyIcon;
      case 'star':
      case 'vip':
      case 'premium':
      case 'crown':
      case 'exclusive':
      case 'royal':
      case 'vintage':
        return vintageIcon;
      default:
        return vintageIcon;
    }
  };

  const src = getIconSrc(icon);

  return (
    <img 
      src={src} 
      alt={icon} 
      className={className} 
      style={{ objectFit: 'contain', filter: 'invert(1)' }}
    />
  );
};
